import { capitalize } from 'lodash';

export function capitalizeEachWordInString(
    string: string,
    options?: {
        // Don't do this to words of the given length
        ignoreWordsOfLength?: number;
    }
) {
    return string
        .split(' ')
        .map((w) => {
            if (w.length === options?.ignoreWordsOfLength) {
                return w;
            }
            return capitalize(w);
        })
        .join(' ');
}
